import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink, Navigate } from 'react-router-dom';
import TestCasesList from './pages/TestCasesList';
import CreateTestCase from './pages/CreateTestCase';
import TestCaseDetail from './pages/TestCaseDetail';
import ExecuteTest from './pages/ExecuteTest';
import DraftResults from './pages/DraftResults';
import MainResults from './pages/MainResults';
import ResultDetail from './pages/ResultDetail';
import DatasetsList from './pages/DatasetsList';
import DatasetDetail from './pages/DatasetDetail';
import ProxiesList from './pages/ProxiesList';
import ProxyInfo from './pages/ProxyInfo';
import ProxyDetail from './pages/ProxyDetail';
import ProxyTraffic from './pages/ProxyTraffic';
import ProxyListsList from './pages/ProxyListsList';
import ProxyListDetail from './pages/ProxyListDetail';
import CurrentPerformance from './pages/CurrentPerformance';
import PerformanceDetail from './pages/PerformanceDetail';
import EndpointEvolution from './pages/EndpointEvolution';
import ProductionTestsList from './pages/ProductionTestsList';
import CreateProductionTest from './pages/CreateProductionTest';
import ProductionTestDetail from './pages/ProductionTestDetail';
import Login from './pages/Login';
import { isAuthenticated } from './services/auth';
import './index.css';


function AppShell({ onLogout }) {
  return (
    <div className="App">
      <nav>
        <div className="container">
          <h1>Endpoint Testing Platform</h1>
          <ul>
            <li><NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}>Test Cases</NavLink></li>
            <li><NavLink to="/production-tests" className={({ isActive }) => isActive ? 'active' : ''}>Production Tests</NavLink></li>
            <li><NavLink to="/datasets" className={({ isActive }) => isActive ? 'active' : ''}>Datasets</NavLink></li>
            <li><NavLink to="/proxies" className={({ isActive }) => isActive ? 'active' : ''}>Proxies</NavLink></li>
            <li><NavLink to="/proxy-lists" className={({ isActive }) => isActive ? 'active' : ''}>Proxy Lists</NavLink></li>
            <li><NavLink to="/draft" className={({ isActive }) => isActive ? 'active' : ''}>Draft Results</NavLink></li>
            <li><NavLink to="/main" className={({ isActive }) => isActive ? 'active' : ''}>Main Results</NavLink></li>
            <li><NavLink to="/performance" className={({ isActive }) => isActive ? 'active' : ''}>Performance</NavLink></li>
            <li><NavLink to="/evolution" className={({ isActive }) => isActive ? 'active' : ''}>Evolution</NavLink></li>
            <li>
              <button
                onClick={onLogout}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', padding: '0', font: 'inherit', opacity: 0.8 }}
              >
                Logout
              </button>
            </li>
          </ul>
        </div>
      </nav>
      <div className="container">
        <Routes>
          <Route path="/" element={<TestCasesList />} />
          <Route path="/create" element={<CreateTestCase />} />
          <Route path="/test-case/:id" element={<TestCaseDetail />} />
          <Route path="/execute/:id" element={<ExecuteTest />} />
          <Route path="/draft" element={<DraftResults />} />
          <Route path="/main" element={<MainResults />} />
          <Route path="/result/:id" element={<ResultDetail />} />
          <Route path="/datasets" element={<DatasetsList />} />
          <Route path="/datasets/:id" element={<DatasetDetail />} />
          <Route path="/proxies" element={<ProxiesList />} />
          <Route path="/proxies/:id/edit" element={<ProxyDetail />} />
          <Route path="/proxies/:id/traffic" element={<ProxyTraffic />} />
          <Route path="/proxies/:id" element={<ProxyInfo />} />
          <Route path="/proxy-lists" element={<ProxyListsList />} />
          <Route path="/proxy-lists/:id" element={<ProxyListDetail />} />
          <Route path="/performance" element={<CurrentPerformance />} />
          <Route path="/performance/:id" element={<PerformanceDetail />} />
          <Route path="/evolution" element={<EndpointEvolution />} />
          {/* Production Tests — /production-tests/test/:id for detail so /:folder is unambiguous */}
          <Route path="/production-tests" element={<ProductionTestsList />} />
          <Route path="/production-tests/create" element={<CreateProductionTest />} />
          <Route path="/production-tests/test/:id" element={<ProductionTestDetail />} />
          <Route path="/production-tests/test/:id/edit" element={<CreateProductionTest />} />
          <Route path="/production-tests/:folder" element={<ProductionTestsList />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  const [authed, setAuthed] = useState(isAuthenticated());

  const handleLogout = () => {
    import('./services/auth').then(({ clearKey }) => clearKey());
    setAuthed(false);
  };

  return (
    <Router>
      {authed
        ? <AppShell onLogout={handleLogout} />
        : (
          <Routes>
            <Route path="/login" element={<Login onLogin={() => setAuthed(true)} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        )
      }
    </Router>
  );
}

export default App;
